import styled from '@emotion/styled'

export const V2L3DashboardListsContainer = styled.div({
	overflow: 'hidden',
	display: 'grid',
	gridTemplateRows: 'fit-content fit-content',
	gap: '1rem',
})
